import React, { FC } from 'react';

import { BUTTON_TYPES, EvConfirm, EvToast } from '@evinced-private/ui-common';

import { SITE_SCANNER_APP_ID } from 'src/consts/dom-consts';

import { PropertyImportUrlsButton } from '../../../components/property-settings/property-import-urls-button/PropertyImportUrlsButton';

import { SEEDS_LABELS } from './SeedsSettingsV2.labels';
import { SeedsTableActionsProps } from './SeedsSettingsV2.types';

export const SeedsTableActions: FC<SeedsTableActionsProps> = ({
	seeds,
	selectedSeeds,
	isListMode,
	isImportInProgress,
	showImportToast,
	importAnnouncement,
	toastStatus,
	onToastClose,
	onImport,
	updatePropertySeeds
}) => {
	const selectedLength = selectedSeeds.length;
	const isSelectedEmpty = selectedLength === 0;
	const isSelectedMultiple = selectedLength > 1;
	const isAllSelected = selectedLength === seeds.length;
	const urlText = `${isSelectedMultiple || (isAllSelected && isSelectedMultiple) ? 'URLs' : 'URL'}`;
	const selectedCountText = isSelectedMultiple ? selectedLength : '';
	const buttonTitle = `Remove ${
		isAllSelected && isSelectedMultiple ? 'All' : selectedCountText
	} ${urlText}`;

	return (
		<div className="table-actions-header">
			{showImportToast && (
				<EvToast
					announcement={importAnnouncement}
					status={toastStatus}
					show={showImportToast}
					onToastClose={onToastClose}
				/>
			)}
			{isListMode && (
				<PropertyImportUrlsButton
					importing={isImportInProgress}
					validHeader={SEEDS_LABELS.IMPORT_VALID_HEADER}
					onConfirm={onImport}
				/>
			)}
			<EvConfirm
				appElement={SITE_SCANNER_APP_ID}
				title={SEEDS_LABELS.CONFIRM_REMOVING_URLS}
				promptMessage={`Are you sure you want to ${buttonTitle.toLocaleLowerCase()}?`}
				triggerButtonProps={{
					type: BUTTON_TYPES.SECONDARY,
					title: buttonTitle,
					disabled: isSelectedEmpty,
					customTooltip: isSelectedEmpty ? { renderTooltip: true } : null,
					disabledReason: SEEDS_LABELS.DISABLED_REASON,
					children: buttonTitle
				}}
				onConfirm={(closeModal) => {
					const newSeeds = seeds.filter((s) => {
						return !selectedSeeds.find((selected) => selected.url === s.url);
					});
					updatePropertySeeds(newSeeds, closeModal);
				}}
			/>
			<EvConfirm
				appElement={SITE_SCANNER_APP_ID}
				title={SEEDS_LABELS.CONFIRM_REMOVING_ALL_URLS}
				promptMessage={`Are you sure you want to clear all URLs? (${seeds.length})`}
				triggerButtonProps={{
					type: BUTTON_TYPES.ACTION,
					title: SEEDS_LABELS.CLEAR_LIST,
					children: SEEDS_LABELS.CLEAR_LIST
				}}
				onConfirm={(closeModal) => {
					updatePropertySeeds([], closeModal);
				}}
			/>
		</div>
	);
};
